// تنظیم «نمایش ناموجودی‌ها» (show_out_of_stock) فقط برای سایت تولیکا.
// وقتی در ادمین غیرفعال باشد، همه محصولات موجود در نظر گرفته می‌شوند و
// برچسب ناموجود نمایش داده نمی‌شود. (سایت‌های دیگر مثل وندا تغییری نمی‌کنند.)
//
// این فایل عمداً 'use server' نیست چون توابع sync هم export می‌کند.
import { getSettings } from './setting';

export const UNLIMITED_INVENTORY = 9999;

const IS_TOLICA_SITE = process.env.NEXT_PUBLIC_SITE_NAME === 'tolica_front';

/** آیا باید ناموجودی‌ها نادیده گرفته شوند؟ (فقط تولیکا + تنظیم غیرفعال) */
export async function isStockIgnored(): Promise<boolean> {
  if (!IS_TOLICA_SITE) return false;
  try {
    const settings = await getSettings();
    const value = settings?.show_out_of_stock;
    return value === 0 || value === '0' || value === false || value === 'false';
  } catch {
    return false;
  }
}

/** همه فیلدهای عددی `inventory` را (به‌صورت بازگشتی) به مقدار نامحدود تبدیل می‌کند */
export function unlockInventory<T>(data: T): T {
  if (Array.isArray(data)) {
    data.forEach((item) => unlockInventory(item));
  } else if (data && typeof data === 'object') {
    const obj = data as Record<string, unknown>;
    for (const key of Object.keys(obj)) {
      if (key === 'inventory' && typeof obj[key] === 'number') {
        obj[key] = UNLIMITED_INVENTORY;
      } else {
        unlockInventory(obj[key]);
      }
    }
  }
  return data;
}

/** اگر تنظیم غیرفعال بود، موجودی همه محصولات داخل پاسخ را نامحدود می‌کند */
export async function applyStockSetting<T>(data: T): Promise<T> {
  return (await isStockIgnored()) ? unlockInventory(data) : data;
}
